// extracted by mini-css-extract-plugin
export default {"title":"DownloadAppSection-module__title__zna+A","goToStoresContainer":"DownloadAppSection-module__goToStoresContainer__cOI5L"};